import React from 'react';
import { Box, Flex } from '../Rebass';
import Text from '../Text';
import Heading from '../Heading';
import { CardProps } from './types';
import Meta from '../Meta';
import { cardHeadlineStyle, cardWrapperStyle } from './common';
import styled from '@emotion/styled';

const CardWrapper = styled(Flex)(cardWrapperStyle);
const StyledHeading = styled(Heading)(cardHeadlineStyle);

const CardStandard = ({
  headline,
  description,
  descriptionHtml,
  image,
  renderCta,
  meta,
  bg,
  padding,
  colorScheme,
  children,
  highlight,
  isLink,
  imageSx,
}: CardProps) => (
  <CardWrapper
    sx={{ position: 'relative' }}
    flexDirection="column"
    alignItems="start"
    bg={bg}
    {...padding}
  >
    {highlight && (
      <Flex
        sx={{
          position: 'absolute',
          top: '12px',
          left: '12px',
          bg: 'white',
          zIndex: 1,
          borderRadius: '4px',
          padding: '4px 5px',
          maxWidth: '50%',
        }}
      >
        <Text
          size="extraSmall"
          sx={{ textTransform: 'uppercase', overflowWrap: 'break-word' }}
        >
          {highlight}
        </Text>
      </Flex>
    )}
    {image ? (
      <Box mb={[3]} width="100%" sx={imageSx}>
        <>{image}</>
      </Box>
    ) : null}
    {Boolean(meta.length) && (
      <Box mb={[1]} width="100%">
        <Meta meta={meta} size="small" />
      </Box>
    )}
    <Box mb={[1]} width="100%">
      <StyledHeading
        className="card-headline"
        isLink={isLink}
        size="h4"
        fontWeight={'normal'}
      >
        {headline}
      </StyledHeading>
    </Box>
    <Box mb={[1]} width="100%">
      {descriptionHtml ? (
        <Text size="small">
          <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        </Text>
      ) : description ? (
        <Text size="small">{description}</Text>
      ) : null}
    </Box>
    {renderCta && renderCta(colorScheme)}
    {children}
  </CardWrapper>
);

CardStandard.defaultProps = {
  headline: '',
  description: '',
  descriptionHtml: null,
  meta: [],
  image: null,
  renderCta: null,
  bg: 'transparent',
  padding: {},
  colorScheme: 'brandBrown',
};

export default CardStandard;